import _axios from '../dependencies/_axios'

export function globalHideSweetAlertSuccess() {
	return {
		type: 'GLOBAL_HIDE_SWEET_ALERT_SUCCESS'
	}
}

export function globalAddSweetAlertDataSuccess(options) {
	return {
		type: 'GLOBAL_ADD_SWEET_ALERT_DATA_SUCCESS',
		options
	}
}

export function globalHideSweetAlert() {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(globalHideSweetAlertSuccess()))
		})
	}
}

export function globalAddSweetAlertData(options) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(globalAddSweetAlertDataSuccess(options)))
		})
	}
}

export function accessLog(companyId, key, id)
{
  return _axios({
    url: "/api/accesslog",
    method: "post",
    data: { company_id: companyId, type: key, key: id }
  })
}